import { render, staticRenderFns } from "./footerNav.vue?vue&type=template&id=052b50f4&lang=pug&"
import script from "./footerNav.vue?vue&type=script&lang=js&"
export * from "./footerNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports